/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaListHeader/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaListHeader({
  children,
  viewPath = "/DesignSystem/TysiaList/TysiaListHeader",
  marginTop,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let marginTopOrdtSpaceXs = marginTop ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="TysiaListHeader.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-2bsJq9': dtColorsNeutral200,'--mt-2-2bsJq9': typeof marginTopOrdtSpaceXs === 'number' ? `${marginTopOrdtSpaceXs}px` : marginTopOrdtSpaceXs,'--mb-3-2bsJq9': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2bsJq9': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2bsJq9': typeof marginRight === 'number' ? `${marginRight}px` : marginRight}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}